module.exports = __webpack_public_path__ + "img/358.a43cc484.png";